<template>
  <div class="page page-with-bg">
    <div class="page-form-wrap">
      <div class="page-form-header" v-if="!showSuccessConfirmation">
        <h1>Reset Password</h1>
        <div class="description">
          <p>Enter your email address that<br /> you used to log in.</p>
        </div>
      </div>
      <div class="page-form-content">
        <b-form @submit.prevent="submit" v-if="!showSuccessConfirmation">
          <validation-summary :errors="errors"></validation-summary>
          <v-form-group :validator="$v.email" label="Email" hide-label>
            <b-form-input 
              slot-scope="{ attrs, listeners }"
              v-bind="attrs"
              v-on="listeners"
              v-model="email" 
              placeholder="Email" 
            />
          </v-form-group>
          <b-form-group class="form-buttons">
            <b-btn 
              :disabled="loading" 
              variant="success" 
              size="lg" 
              type="submit"
            >
              Send Recovery Link
            </b-btn>
          </b-form-group>
        </b-form>
        <div class="password-sent" v-else>
          <div class="password-sent-icon">
            <svg-icon name="message" />
          </div>
          <h2 class="password-sent-title">
            Link Sent
          </h2>
          <div class="password-sent-text">
            <label>We sent a recovery link to you at</label>
            <div>{{ email }}</div>
          </div>
          <div class="password-sent-buttons">
            <router-link
              to="/login"
              class="btn btn-light"
            >
              Return to Log In
            </router-link>
            <b-btn
              :disabled="loading"
              @click="resendLink"
              variant="light"
            >
              Resend Recovery Link
            </b-btn>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { required, email } from "vuelidate/lib/validators";
import accountService from "services/account-service";
import formMixin from "mixins/form-mixin";

export default {
  mixins: [formMixin],

  data() {
    return {
      loading: false,
      email: "",
      showSuccessConfirmation: false
    };
  },

  validations: {
    email: {
      required,
      email
    }
  },

  methods: {
    async resendLink() {
      this.loading = true;
      await accountService.forgotPassword({ email: this.email });
      this.loading = false;
      this.$root.successToast('Link successfully resent!');
    },

    async onSubmit() {
      this.loading = true;
      await accountService.forgotPassword({ email: this.email });
      this.loading = false;
      this.showSuccessConfirmation = true;
    }
  }
};
</script>
<style scoped lang="scss">
  @import '@/styles/variables';
  @import '@/styles/mixins';

  .page {
    @include retina('/png/stethoscope.png');

    .password-sent {
      .password-sent-icon {
        .svg-icon {
          width: 15rem;
          height: auto;
          margin-bottom: 1.25rem;
        }
      }

      .password-sent-title {
        font-size: 3rem;
        font-weight: 300;
        margin-bottom: 1rem;
      }

      .password-sent-text {
        font-size: 1.125rem;

        > label {
          color: $body-color;
        }

        > div {
          color: $text-color;
        }
      }

      .password-sent-buttons {
        padding-top: 2.5rem;

        > .btn {
          & + .btn {
            margin-left: 1rem;
          }
        }
      }
    }
  }
</style>